import React from 'react';
import HomePandaSignImg from '../../assets/images/panda_sign.png';

interface HomePandaSignProps {
  message: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const HomePandaSign = ({ message, style = {}, onClick }: HomePandaSignProps) => {
  if (!message) {
    return null;
  }

  return (
    <div onClick={onClick}>
      <div
        style={{
          ...style,
          maxWidth: '200px',
          height: 'auto',
          position: 'relative',
        }}
      >
        <img
          src={HomePandaSignImg}
          alt="Panda with sign"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            margin: '0 auto',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '-65px',
            left: '-75px',
            transform: 'rotate(-10deg)',
            backgroundColor: '#ceb076',
            border: '5px solid #bc9444',
            borderRadius: '8px',
            padding: '8px 12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            zIndex: 100,
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center',
            maxWidth: '120px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
          }}
        >
          {message}
        </div>
      </div>
    </div>
  );
};